import { useEffect, useRef } from 'react';
import { useCheckoutState } from '../../utils/checkoutState';
import { mountScript } from '../../utils/useScript';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    _itt?: { c: string; s: string; t: string };
  }
}

const AFTERPAY_CLIENT_ID = '71597';

const AfterpayPayment = () => {
  const { checkoutState } = useCheckoutState();
  const token = checkoutState.orderState.payment?.selected?.[0].configuration?.initializationData?.deviceIdent?.token;
  const previousToken = useRef();

  useEffect(() => {
    if (!token || token === previousToken.current) {
      return;
    }

    previousToken.current = token;
    window._itt = { c: AFTERPAY_CLIENT_ID, s: token, t: 'CO' };
    mountScript(`https://uc8.tv/${AFTERPAY_CLIENT_ID}.js`);
    // eslint-disable-next-line consistent-return
    return () => {
      delete window._itt;
    };
  }, [token, previousToken]);

  return null;
};

export default AfterpayPayment;
